const identity = a => a
const getType = action => action && action.type

export default (reducers = {}, initialState = null) => (
  state = initialState,
  action = {}
) => (reducers[getType(action)] || identity)(state, action)
